import { render, staticRenderFns } from "./migrateGroup.vue?vue&type=template&id=292d46c1&scoped=true&"
import script from "./migrateGroup.vue?vue&type=script&lang=js&"
export * from "./migrateGroup.vue?vue&type=script&lang=js&"
import style0 from "./migrateGroup.vue?vue&type=style&index=0&id=292d46c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d46c1",
  null
  
)

export default component.exports